import { FILTER_CATEGORIES } from "../constants/filterCategories";
import { createFilterHelpers } from "./filterUtils";

export const { emptyFilters, cycleFilterValue, itemMatchesFilters } =
  createFilterHelpers(FILTER_CATEGORIES);

export const matchesSearch = (item, query) => {
  const trimmed = query.trim().toLowerCase();
  if (!trimmed) return true;
  const values = [
    item.title,
    item.description,
    ...FILTER_CATEGORIES.flatMap(({ getValues }) => getValues(item)),
  ];
  return values.some((value) => (value || "").toLowerCase().includes(trimmed));
};

export const clearInvalidFilters = (filters, items) => {
  const next = { ...filters };
  for (const { key, getValues } of FILTER_CATEGORIES) {
    const entries = next[key];
    if (!entries) continue;
    const updated = { ...entries };
    let changed = false;
    for (const value of Object.keys(entries)) {
      const hasMatch = items.some((item) => getValues(item).includes(value));
      if (!hasMatch) {
        delete updated[value];
        changed = true;
      }
    }
    if (changed) next[key] = updated;
  }
  return next;
};

export const getCategoryOptions = (items, key, valueComparators) => {
  const category = FILTER_CATEGORIES.find((c) => c.key === key);
  const values = [...new Set(items.flatMap(category.getValues))].filter(
    Boolean,
  );
  const compare = valueComparators?.[key];
  return compare ? values.sort(compare) : values.sort();
};
